module.exports = __webpack_public_path__ + "img/casetop.8ff74ae8.jpg";